module.exports = __webpack_public_path__ + "img/download_bg.c87a28ed.jpg";